import { footerColumns } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-5">
          <div className="font-logo text-2xl text-primary-600">黑吃瓜网</div>
          <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
            一个把过往条目录好号、存好档的资讯聚合门户。黑料存档、黑料合集、黑料整理按题材与年份归档，
            想查完整黑料大全，在这里一次看个够。
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            {['黑料存档', '黑料合集', '黑料整理', '黑料大全'].map((tag) => (
              <span
                key={tag}
                className="rounded-md border border-secondary-200 bg-secondary-50 px-2.5 py-1 text-xs text-secondary-900"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {footerColumns.map((col) => (
          <div key={col.title} className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-900">
              <a href="#top" className="cursor-pointer">
                {col.title}
              </a>
            </h4>
            <ul className="mt-3 flex flex-col gap-2">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="cursor-pointer text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="lg:col-span-1">
          <h4 className="font-heading text-sm font-bold text-foreground-900">
            <a href="#discussion" className="cursor-pointer">
              关注
            </a>
          </h4>
          <div className="mt-3 flex flex-col gap-2">
            <a
              href="#discussion"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-wechat-line"></i>
            </a>
            <a
              href="#discussion"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-weibo-line"></i>
            </a>
            <a
              href="#discussion"
              className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-mail-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200 bg-background-200">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col gap-2 px-4 py-4 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between md:px-6 lg:px-10">
          <span>© 2026 黑吃瓜网 · 内容仅为信息聚合与存档展示</span>
          <span className="flex flex-wrap items-center gap-4">
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              免责说明
            </a>
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              内容纠错
            </a>
            <a href="#top" className="cursor-pointer transition-colors hover:text-primary-700">
              存档规范
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}